import { useApiFetcherSWR } from "hooks/SwrCustom";

export const API_ENDPOINT = {
    CONTRACT_LIST: {
        url: "gebruiker/contract/list",
        method: "get",
    },

    CONTRACT_UPDATE: {
        url: "gebruiker/save-contract",
        method: "post",
    },
    GET_INSTELLINGEN_INFO: {
        url: "gebruiker/save-instellingen-info",
        method: "post",
    },

    SAVE_INSTELLINGEN_INFO: {
        url: "gebruiker/instellingen/save",
        method: "post",
    },
    CONTRACT_TYPE: {
        url: "contracttypes",
        method: "get",
    },

    UPDATE_INSTELLINGEN_DETAIL: {
        url: "gebruiker/save-instellingen",
        method: "post",
    },
};

// GET contracts (if needed)
export const useContractList = () =>
    useApiFetcherSWR(API_ENDPOINT.CONTRACT_LIST);

// POST add/edit/delete contract
export const useContractUpdate = () =>
    useApiFetcherSWR(API_ENDPOINT.CONTRACT_UPDATE);
export const useInstellingenInfo = () =>
    useApiFetcherSWR(API_ENDPOINT.GET_INSTELLINGEN_INFO);

// POST / save instellingen
export const useSaveInstellingenInfo = () =>
    useApiFetcherSWR(API_ENDPOINT.SAVE_INSTELLINGEN_INFO);

export const useContractType = (iCommunityId, iAdminId) =>
    useApiFetcherSWR({
        ...API_ENDPOINT.CONTRACT_TYPE,
        params: {
            iCommunityId,
            iAdminId,
        },
    });

// POST update instellingen field
export const useUpdateInstellingenDetail = () =>
    useApiFetcherSWR(API_ENDPOINT.UPDATE_INSTELLINGEN_DETAIL);